/**
 * Display formatting honouring the team's preferences.
 */
import { labelOf, type Option } from "@shared/constants.ts";
import { formatDate as fmtDate } from "@shared/dates.ts";
import { formatPence } from "@shared/money.ts";
import { useAuth } from "./auth.tsx";

export function useFormat() {
  const { me } = useAuth();
  const dateFormat = me?.preferences?.dateFormat ?? "d MMM yyyy";
  const timeZone = me?.preferences?.timezone ?? "Europe/London";
  return {
    money: (pence: number | null | undefined, opts?: { whole?: boolean }) =>
      pence === null || pence === undefined ? "—" : formatPence(pence, opts),
    date: (iso: string | null | undefined) => (iso ? fmtDate(iso.slice(0, 10), dateFormat) : "—"),
    dateTime: (iso: string | null | undefined) =>
      iso
        ? new Intl.DateTimeFormat("en-GB", { dateStyle: "medium", timeStyle: "short", timeZone }).format(
            new Date(iso),
          )
        : "—",
    label: (list: readonly Option[], value: string | null | undefined) => labelOf(list, value) || "—",
  };
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 ** 3) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 ** 3).toFixed(bytes < 10 * 1024 ** 3 ? 2 : 1)} GB`;
}

export function percent(bp: number): string {
  return `${(bp / 100).toFixed(bp % 100 === 0 ? 0 : 2)}%`;
}
